import '../../App.css';
import React, { useContext } from "react";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';

function ModalCadastrarAvaliacao({ closeModal, currentPage }) {
    const { CadastrarAvaliacao, AvaliacaoCadastro, setAvaliacaoCadastro } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const handleClose = () => {
        setAvaliacaoCadastro({ descricao: "" });
        closeModal(false);
    };

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar avaliação</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarAvaliacao(e, currentPage)}>
                    <div className="modal-content">
                        <Row>
                            <Form.Group className="mb-3">
                                <Form.Label>Avaliação</Form.Label>
                                <Form.Control maxLength={100} onChange={(e) => setAvaliacaoCadastro({ ...AvaliacaoCadastro, descricao: e.target.value })} value={AvaliacaoCadastro.descricao} />
                            </Form.Group>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                        <button className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarAvaliacao